var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationsIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2659 4.6772C12.6874 4.34375 14.1668 4.34375 15.5884 4.6772C17.4413 5.11185 18.8882 6.55866 19.3228 8.41162C19.6562 9.83317 19.6562 11.3126 19.3228 12.7341C19.1087 13.647 18.6489 14.4614 18.0158 15.1047C18.2314 13.7218 18.1788 12.3076 17.858 10.9399C17.2995 8.55929 15.4407 6.70045 13.0601 6.14203C11.6924 5.82122 10.2782 5.76862 8.89533 5.9842C9.53863 5.35114 10.353 4.89133 11.2659 4.6772ZM20.7122 13.0601C20.2712 14.94 19.0194 16.4944 17.3401 17.3401C16.4944 19.0194 14.94 20.2712 13.0601 20.7122C11.4241 21.0959 9.72163 21.0959 8.08571 20.7122C5.70506 20.1538 3.84623 18.2949 3.2878 15.9143C2.90407 14.2784 2.90407 12.5759 3.2878 10.9399C3.72876 9.06007 4.98057 7.50558 6.65987 6.65982C7.50562 4.9806 9.05997 3.72878 10.9399 3.2878C12.5759 2.90407 14.2784 2.90407 15.9143 3.2878C18.2949 3.84623 20.1538 5.70506 20.7122 8.08571C21.0959 9.72162 21.0959 11.4241 20.7122 13.0601ZM7.24369 11.6834C7.41857 11.421 7.77299 11.3502 8.03531 11.525L9.83405 12.7242C10.2815 13.0225 10.8643 13.0225 11.3117 12.7242L13.1105 11.525C13.3728 11.3502 13.7272 11.421 13.9021 11.6834C14.077 11.9457 14.0061 12.3001 13.7438 12.475L11.945 13.6741C11.1141 14.2281 10.0317 14.2281 9.20075 13.6741L7.40202 12.475C7.1397 12.3001 7.06881 11.9457 7.24369 11.6834Z",
    fill: "#0E9AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationsIconFilled);
export default __webpack_public_path__ + "static/media/organizationsIconFilled.a8750257fe2d31bcd4cdee6b0529d3fc.svg";
export { ForwardRef as ReactComponent };